/** Default Vivint recruiting / signed-reps season year (Sep season rollover). */
export const DEFAULT_SEASON_YEAR = "2027"
export const DEFAULT_SEASON_YEAR_NUMBER = 2027

export const SEASON_YEAR_OPTIONS = [
  "2023",
  "2024",
  "2025",
  "2026",
  "2027",
] as const

export const SEASON_YEAR_OPTIONS_WITH_ALL = [
  "All",
  ...SEASON_YEAR_OPTIONS,
] as const

/** Newest season first (for report year dropdowns). */
export function seasonYearsDescending(
  newest = DEFAULT_SEASON_YEAR_NUMBER,
  count = SEASON_YEAR_OPTIONS.length
): number[] {
  const years: number[] = []
  for (let i = 0; i < count; i++) {
    years.push(newest - i)
  }
  return years
}

/** Weekly training / blitz season window (Oct prior year through early May). */
export function seasonMeetingDateBounds(
  seasonYear: number | string = DEFAULT_SEASON_YEAR_NUMBER
) {
  const y = Number(seasonYear)
  return {
    min: `${y - 1}-10-01`,
    max: `${y}-05-04`,
  }
}
